import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_ORDER_URL

const _get = async (queryParamFilters, queryParam, setParams, setMetadata, setUdfFields) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParamFilters || undefined,
  }

  setParams?.(params)

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/scheduler',
    params: params,
  })

  setMetadata?.(response?.data.metadata)

  const paginated_result = response?.data?.data?.paginated_result

  setUdfFields?.(paginated_result?.[0]?.user_definition_fields || [])

  const modifiedPaginatedResult = paginated_result?.map((result) => {
    const customFields = result.user_definition_fields?.reduce(
      (prev, curr) => ({ ...prev, [curr.key]: curr }),
      {}
    )
    return { ...result, ...customFields }
  })

  return {
    ...response?.data,
    data: {
      ...response?.data.data,
      paginated_result: modifiedPaginatedResult,
    },
  }
}

export const get =
  (queryParamFilters, setParams, setMetadata, setUdfFields) => async (queryParam) =>
    await _get(queryParamFilters, queryParam, setParams, setMetadata, setUdfFields)

export const store = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/scheduler',
    data,
  })

  return response?.data
}

export const show = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/scheduler/${id}`,
  })

  return response?.data
}

export const update = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PATCH',
    url: `/scheduler/${id}`,
    data,
  })

  return response?.data
}

export const transition = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/scheduler/${id}/transition`,
    data
  })

  return response?.data
}

export const helper = async (params) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/scheduler/recurrence`,
    params,
  })

  return response?.data
}

export const deleteMany = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/scheduler/delete`,
    data,
  })

  return response?.data
}
